import { Share2, Twitter, Facebook, Link2, Check } from 'lucide-react';
import { logger } from '../utils/logger';
import { useState } from 'react';
import { toast } from 'sonner';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';

export const ShareButtons = ({ title, url, type = 'track' }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const shareText = `Check out "${title}" by @DaRealQJones! 🎵`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error('Failed to copy link');
    }
  };

  const shareToTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(twitterUrl, '_blank', 'width=550,height=420');
  };

  const shareToFacebook = () => {
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(fbUrl, '_blank', 'width=550,height=420');
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: shareText,
          url: shareUrl
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          logger.error('Share failed:', error);
        }
      }
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="btn-ghost flex items-center gap-2" data-testid="share-button">
          <Share2 className="w-4 h-4" />
          Share
        </button>
      </PopoverTrigger>
      <PopoverContent className="bg-[#0a0a0a] border-white/10 w-48 p-2" align="end">
        <div className="space-y-1">
          <button
            onClick={shareToTwitter}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white/5 text-left"
            data-testid="share-twitter"
          >
            <Twitter className="w-4 h-4 text-[#1DA1F2]" />
            <span className="text-sm">Twitter</span>
          </button>
          <button
            onClick={shareToFacebook}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white/5 text-left"
            data-testid="share-facebook"
          >
            <Facebook className="w-4 h-4 text-[#4267B2]" />
            <span className="text-sm">Facebook</span>
          </button>
          <button
            onClick={handleCopyLink}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white/5 text-left"
            data-testid="share-copy"
          >
            {copied ? <Check className="w-4 h-4 text-green-400" /> : <Link2 className="w-4 h-4" />}
            <span className="text-sm">{copied ? 'Copied!' : 'Copy Link'}</span>
          </button>
          {navigator.share && (
            <button
              onClick={handleNativeShare}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white/5 text-left"
              data-testid="share-native"
            >
              <Share2 className="w-4 h-4" />
              <span className="text-sm">More...</span>
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
